import { render } from "./UserLabelFormPage.vue?vue&type=template&id=2cf92104&ts=true"
import script from "./UserLabelFormPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserLabelFormPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/user-label/UserLabelFormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cf92104"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cf92104', __exports__)) {
    api.reload('2cf92104', __exports__)
  }
  
  module.hot.accept("./UserLabelFormPage.vue?vue&type=template&id=2cf92104&ts=true", () => {
    api.rerender('2cf92104', render)
  })

}


export default __exports__